import styled, { css } from 'styled-components';

import {
    CONTENT_BASE,
    CONTENT_DISABLED,
    CONTENT_MUTED,
    NEGATIVE_BASE,
    NEGATIVE_DISABLED,
    NEGATIVE_MUTED,
    POSITIVE_BASE,
    POSITIVE_DISABLED,
    POSITIVE_MUTED,
    PRIMARY_BASE,
    PRIMARY_DISABLED,
    PRIMARY_MUTED,
    SECONDARY_BASE,
    SECONDARY_DISABLED,
    SECONDARY_MUTED,
    SURFACE_BASE,
} from '@amzn/ring-common-style-library/lib/colors';

import {
    BODY_SMALL_MEDIUM,
} from '@amzn/ring-common-style-library/lib/typography';

interface BadgeStyledProps {
    type: 'solid' | 'outline' | 'faded';
    color: 'primary' | 'positive' | 'secondary' | 'negative' | 'neutral';
    disabled?: boolean;
}


const solidBadgeColors = {
    primary: css<BadgeStyledProps>`
        background-color: ${({ disabled }) => disabled ? PRIMARY_DISABLED : PRIMARY_BASE};
        color: ${SURFACE_BASE};
        border: 0px;
    `,
    positive: css<BadgeStyledProps>`
        background-color: ${({ disabled }) => disabled ? POSITIVE_DISABLED : POSITIVE_BASE};
        color: ${SURFACE_BASE};
        border: 0px;
    `,
    secondary: css<BadgeStyledProps>`
        background-color: ${({ disabled }) => disabled ? SECONDARY_DISABLED : SECONDARY_BASE};
        color: ${SURFACE_BASE};
        border: 0px;
    `,
    negative: css<BadgeStyledProps>`
        background-color: ${({ disabled }) => disabled ? NEGATIVE_DISABLED : NEGATIVE_BASE};
        color: ${SURFACE_BASE};
        border: 0px;
    `,
    neutral: css<BadgeStyledProps>`
        background-color: ${({ disabled }) => disabled ? CONTENT_DISABLED : CONTENT_BASE};
        color: ${SURFACE_BASE};
        border: 0px;
    `,
};

const outlineBadgeColors = {
    primary: css<BadgeStyledProps>`
        border: 1px solid ${({ disabled }) => disabled ? PRIMARY_DISABLED : PRIMARY_BASE};
        color: ${({ disabled }) => disabled ? PRIMARY_DISABLED : PRIMARY_BASE};
    `,
    positive: css<BadgeStyledProps>`
        border: 1px solid ${({ disabled }) => disabled ? POSITIVE_DISABLED : POSITIVE_BASE};
        color: ${({ disabled }) => disabled ? POSITIVE_DISABLED : POSITIVE_BASE};
    `,
    secondary: css<BadgeStyledProps>`
        border: 1px solid ${({ disabled }) => disabled ? SECONDARY_DISABLED : SECONDARY_BASE};
        color: ${({ disabled }) => disabled ? SECONDARY_DISABLED : SECONDARY_BASE};
    `,
    negative: css<BadgeStyledProps>`
        border: 1px solid ${({ disabled }) => disabled ? NEGATIVE_DISABLED : NEGATIVE_BASE};
        color: ${({ disabled }) => disabled ? NEGATIVE_DISABLED : NEGATIVE_BASE};
    `,
    neutral: css<BadgeStyledProps>`
        border: 1px solid ${({ disabled }) => disabled ? CONTENT_DISABLED : CONTENT_BASE};
        color: ${({ disabled }) => disabled ? CONTENT_DISABLED : CONTENT_BASE};
    `,
};

const fadedBadgeColors = {
    primary: css<BadgeStyledProps>`
        color: ${({ disabled }) => disabled ? PRIMARY_DISABLED : PRIMARY_BASE};
        background-color: ${PRIMARY_MUTED};
        border: 0px;
    `,
    positive: css<BadgeStyledProps>`
        color: ${({ disabled }) => disabled ? POSITIVE_DISABLED : POSITIVE_BASE};
        background-color: ${POSITIVE_MUTED};
        border: 0px;
    `,
    secondary: css<BadgeStyledProps>`
        color: ${({ disabled }) => disabled ? SECONDARY_DISABLED : SECONDARY_BASE};
        background-color: ${SECONDARY_MUTED};
        border: 0px;
    `,
    negative: css<BadgeStyledProps>`
        color: ${({ disabled }) => disabled ? NEGATIVE_DISABLED : NEGATIVE_BASE};
        background-color: ${NEGATIVE_MUTED};
        border: 0px;
    `,
    neutral: css<BadgeStyledProps>`
        color: ${({ disabled }) => disabled ? CONTENT_DISABLED : CONTENT_BASE};
        background-color: ${CONTENT_MUTED};
        border: 0px;
    `,
};

const badgeTypes = {
    solid: solidBadgeColors,
    outline: outlineBadgeColors,
    faded: fadedBadgeColors,
};

const Badge = styled.div<{
    type: 'solid' | 'outline' | 'faded';
    color: 'primary' | 'positive' | 'secondary' | 'negative' | 'neutral';
    disabled?: boolean;
}>`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px 8px;
    border-radius: 4px;
    ${BODY_SMALL_MEDIUM};
    ${({ type, color, disabled }) => badgeTypes[type][color]}
`;

export default {
    Badge
};